import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiCode } from 'react-icons/fi';

export const PlaceholderPage = ({ title }) => {
  return (
    <div className="p-6 h-[calc(100vh-4rem)] flex flex-col items-center justify-center text-center">
      <div className="w-16 h-16 bg-chefPanel rounded-full flex items-center justify-center mb-4 text-receiptMuted">
        <SafeIcon icon={FiCode} className="w-8 h-8" />
      </div>
      <h1 className="text-2xl font-bold text-receiptWhite tracking-tight mb-2">{title} Module</h1>
      <p className="text-receiptMuted text-sm max-w-md">
        This functional area is currently in development for the next deployment cycle. Use the Command Dashboard for primary operations.
      </p>
    </div>
  );
};